//  SQL to generate this file - Set SQL query to text output CTRL + T in SQL Server Management Studio

/*

SET NOCOUNT ON
SELECT cast('
/** @description ' + LEFT(cDescription, 100) + ' *' + '/
export const ' + MuellerGlobalData.dbo.Code_Char_GenerateFromName(cName) + ' = "' + cName + '";' as varchar(max))
FROM MuellerGlobalData.dbo.Rights r
ORDER BY cName

*/





/** @description Allow to view the QA Summary page */
export const ACCESS_QA_SUMMARY_VIEW = "Access QA Summary View";

/** @description Allow user to edit All Appraisal Account Settings for an Account/Survey Type setup (Workflow, Minute */
export const ACCOUNT_APPRAISAL_SETTINGS_EDIT = "Account Appraisal Settings Edit";

/** @description Can edit billing settings on customer survey type configuration */
export const ACCOUNT_BILLING_SETTINGS_EDIT = "Account Billing Settings Edit";

/** @description Able to edit Email Case Settings on Survey Type Settings */
export const ACCOUNT_EMAIL_SETTINGS_EDIT = "Account Email Settings Edit";

/** @description Can edit field settings on customer survey type configuration */
export const ACCOUNT_FIELD_SETTINGS_EDIT = "Account Field Settings Edit";

/** @description Can edit QA settings on customer survey type configuration */
export const ACCOUNT_QA_SETTINGS_EDIT = "Account QA Settings Edit";

/** @description Shows the action button to convert an ACE+PDR to an appraisal in any case status */
export const ACE_PDR_CONVERT_TO_APPRAISAL_ANY_STATUS = "ACE PDR Convert to Appraisal - Any Status";

/** @description Shows the action button to convert an ACE+PDR to an appraisal after the case is completed */
export const ACE_PDR_CONVERT_TO_APPRAISAL_COMPLETED = "ACE PDR Convert to Appraisal - Completed";

/** @description Allow user to add cases. */
export const ADD = "ADD";

/** @description Able to add new appraiser */
export const ADD_NEW_APPRAISER = "Add New Appraiser";

/** @description Allow user to add users. */
export const ADDUSERS = "ADDUSERS";

/** @description Allows users to have agent codes */
export const AGENT_CODE_LIMITATIONS = "Agent Code Limitations";

/** @description Users with this right will only see the short list of agents linked to them when viewing an agent dr */
export const AGENT_VIEW_BY_AUTHORIZED_ACCOUNTS = "Agent View By Authorized Accounts";

/** @description A user with this right will be able to log time for any date within the current payroll pay period o */
export const ALLOWEDITDATEFORFRTIMELOG = "ALLOWEDITDATEFORFRTIMELOG";

/** @description Allow user to view and edit personal application */
export const APPLICANT = "APPLICANT";

/** @description Allowed to perform all Appriasal case action given that the action is allowed in the current Apprais */
export const APPRAISAL_ALL_ACTIONS = "Appraisal All Actions";

/** @description Can edit appraisal assignment approvals */
export const APPRAISAL_ASSIGNMENT_APPROVAL_EDIT = "Appraisal Assignment Approval Edit";

/** @description Can view appraisal assignment approvals */
export const APPRAISAL_ASSIGNMENT_APPROVAL_VIEW = "Appraisal Assignment Approval View";

/** @description Base quicklist query for appraisal cases */
export const APPRAISAL_CASE_BASE_QUERY = "Appraisal Case Base Query";

/** @description Allow user to convert an appraisal to a different type */
export const APPRAISAL_CONVERT = "Appraisal Convert";

/** @description Allow user to view appraisal coverage map */
export const APPRAISAL_COVERAGE_MAP = "Appraisal Coverage Map";

/** @description Allowed To edit Appraisals in an editable status regardless of if Appraiser allows edits */
export const APPRAISAL_EDIT_ALLOW_EDITS_OVERRIDE = "Appraisal Edit Allow Edits Override";

/** @description Allowed To edit Appraisals in Appraisal Status RECONSIDERATION_PENDING if user would be allowed to o */
export const APPRAISAL_EDIT_RECONSIDERATION_PENDING = "Appraisal Edit RECONSIDERATION_PENDING";

/** @description Allow user to edit Appraisal ETA field */
export const APPRAISAL_ETA_EDIT = "Appraisal ETA Edit";

/** @description Allow user to add/remove watches for appraisal events */
export const APPRAISAL_EVENT_WATCH = "Appraisal Event Watch";

/** @description Allows submitting the appraisal for GAAR */
export const APPRAISAL_GAAR_SUBMIT = "Appraisal GAAR Submit";

/** @description Allows viewing GAAR Results */
export const APPRAISAL_GAAR_VIEW = "Appraisal GAAR View";

/** @description Allows user to accept or decline an order in Appraisal Port */
export const APPRAISAL_PORT_ACCEPT_DECLINE_ORDER = "Appraisal Port Accept Decline Order";

/** @description Allow user to add a message to an Appraisal Port Case */
export const APPRAISAL_PORT_MESSAGE_ADD = "Appraisal Port Message Add";

/** @description Allows user to move a case to the top of the Queue */
export const APPRAISAL_QUEUE_CASE_MOVE_TO_TOP = "Appraisal Queue Case Move To Top";

/** @description Allowed to view Appraiser forms on Appraisal cases */
export const APPRAISAL_SHOW_APPRAISER_FORMS = "Appraisal show Appraiser forms";

/** @description Allowed to submit Appraisals to QA2 */
export const APPRAISAL_SUBMIT_ACTION = "Appraisal Submit Action";

/** @description Appraiser submit appraisal quality feedback survey */
export const APPRAISAL_SUBMIT_FEEDBACK_REQUIRED = "Appraisal Submit Feedback Required";

/** @description Shows the link to Appraisal Training material */
export const APPRAISAL_TRAINING_VIEW = "Appraisal Training View";

/** @description Allow user to submit to UCDP */
export const APPRAISAL_UCDP_SUBMIT = "Appraisal UCDP Submit";

/** @description View Information related to UCDP Submissions */
export const APPRAISAL_UCDP_VIEW = "Appraisal UCDP View";

/** @description Allow creation of appraiser rejection customer service incidents */
export const APPRAISER_ADD_INCIDENT = "Appraiser Add Incident";

/** @description Allow user to add/edit/delete appraiser administrative time */
export const APPRAISER_ADMIN_TIME_LOG_EDIT = "Appraiser Admin Time Log Edit";

/** @description Allow user to view appraiser administrative time */
export const APPRAISER_ADMIN_TIME_LOG_VIEW = "Appraiser Admin Time Log View";

/** @description Base query for appraiser quick list */
export const APPRAISER_BASE_QUERY = "Appraiser Base Query";

/** @description Allow user to Add, Update, or Delete Appraiser County Proficiency Files */
export const APPRAISER_COUNTY_FILES_EDIT = "Appraiser County Files Edit";

/** @description Allow user to view Appraiser County Proficiency Files */
export const APPRAISER_COUNTY_FILES_VIEW = "Appraiser County Files View";

/** @description User has the ability to edit an appraisers county proficiency */
export const APPRAISER_COUNTY_PROFICIENCY_EDIT = "Appraiser County Proficiency Edit";

/** @description User has the ability to view appraisers county proficiency */
export const APPRAISER_COUNTY_PROFICIENCY_VIEW = "Appraiser County Proficiency View";

/** @description Able to create appraisers */
export const APPRAISER_CREATE = "Appraiser Create";

/** @description Able to edit appraisers */
export const APPRAISER_EDIT = "Appraiser Edit";

/** @description Allows a user to mark an appraiser inactive. It will hide the user from being assigned to cases */
export const APPRAISER_INACTIVE_EDIT = "Appraiser Inactive Edit";

/** @description Allow user to add an appraiser license information */
export const APPRAISER_LICENSE_ADD = "Appraiser License Add";

/** @description Allow user to delete an appraiser license information */
export const APPRAISER_LICENSE_DELETE = "Appraiser License Delete";

/** @description Allow user to edit an appraiser license information */
export const APPRAISER_LICENSE_EDIT = "Appraiser License Edit";

/** @description Allow user to view an appraiser license information */
export const APPRAISER_LICENSE_VIEW = "Appraiser License View";

/** @description Able to export appraiser list */
export const APPRAISER_LIST_EXPORT = "Appraiser List Export";

/** @description Shows MAC Bonus menu item */
export const APPRAISER_MAC_BONUS_SHOW = "Appraiser MAC Bonus Show";

/** @description Appraiser Order Requirements Edit */
export const APPRAISER_ORDER_REQUIREMENTS_EDIT = "Appraiser Order Requirements Edit";

/** @description Show the Appraiser Order Requirements form on cases */
export const APPRAISER_ORDER_REQUIREMENTS_FORM_VIEW = "Appraiser Order Requirements Form View";

/** @description Appraiser Order Requirements View */
export const APPRAISER_ORDER_REQUIREMENTS_VIEW = "Appraiser Order Requirements View";

/** @description Allow user to upload an appraiser signature image */
export const APPRAISER_SIGNATURE_EDIT = "Appraiser Signature Edit";

/** @description Allow user to view an appraiser signature */
export const APPRAISER_SIGNATURE_VIEW = "Appraiser Signature View";

/** @description User is able to modify what regions are assigned to an Appraiser Support Employee */
export const APPRAISER_SUPPORT_REGION_MAINTENANCE = "Appraiser Support Region Maintenance";

/** @description Allow user to Edit the Appraiser Survey group fees */
export const APPRAISER_SURVEY_FEES_EDIT = "Appraiser Survey Fees Edit";

/** @description Allow user to view the Appraiser Survey group fees */
export const APPRAISER_SURVEY_FEES_VIEW = "Appraiser Survey Fees View";

/** @description Able to log time to an appraisal survey */
export const APPRAISER_TIMELOGS_ADD = "Appraiser Timelogs Add";

/** @description Able to approve appraiser time logs */
export const APPRAISER_TIMELOGS_APPROVE = "Appraiser TimeLogs Approve";

/** @description Allow user to access Appraiser Timelogs Approve View */
export const APPRAISER_TIMELOGS_APPROVE_VIEW = "Appraiser Timelogs Approve View";

/** @description Able to view appraisers */
export const APPRAISER_VIEW = "Appraiser View";

/** @description Allow user to assign unassigned cases */
export const ASSIGN = "ASSIGN";

/** @description Able to use Assignment Tool for Appraisal */
export const ASSIGNMENTTOOLAPPRAISAL = "AssignmentToolAppraisal";

/** @description Able to use Assignment Tool for Insurance */
export const ASSIGNMENTTOOLINSURANCE = "AssignmentToolInsurance";

/** @description Allow user to view Audit QA Mappings */
export const AUDIT_QA_QUEUE_MAPPING_VIEW = "Audit QA Queue Mapping View";

/** @description Allows user add or remove account associated to a login */
export const AUTHENTICATION_COMPANIES_EDIT = "Authentication Companies Edit";

/** @description Able to edit authentication user info */
export const AUTHENTICATION_EDIT = "Authentication Edit";

/** @description Able to view authentication user list */
export const AUTHENTICATION_LIST = "Authentication List";

/** @description Able to view authentication card and disable users. */
export const AUTHENTICATION_VIEW = "Authentication View";

/** @description Base quicklist query for broker cases */
export const BROKER_CASE_BASE_QUERY = "Broker Case Base Query";

/** @description Displayes case header specific to brokers */
export const BROKER_CASE_HEADER = "Broker Case Header";

/** @description Base quick list query for broker feedback */
export const BROKER_FEEDBACK_BASE_QUERY = "Broker Feedback Base Query";

/** @description Shows BusOps MAC Bonus menu item */
export const BUSOPS_AGENT_MAC_BONUS_SHOW = "BusOps Agent MAC Bonus Show";

/** @description Able to approve BusOps TimeLogs */
export const BUSOPS_TIMELOGS_APPROVE = "BusOps TimeLogs Approve";

/** @description Able to view BusOps TimeLogs */
export const BUSOPS_TIMELOGS_VIEW = "BusOps TimeLogs View";

/** @description Able to view BusOps TimeLogs for all supervisors */
export const BUSOPS_TIMELOGS_VIEW_ALL = "BusOps TimeLogs View All";

/** @description Able to edit calc header settings for individual cases */
export const CALC_HEADER_SETTINGS_EDIT = "Calc Header Settings Edit";

/** @description Displays a message when viewing the employee calendar that the employee is not in compliance with th */
export const CALENDAR_COMPLIANCE_MESSAGE_SHOW = "Calendar Compliance Message Show";

/** @description Makes the users home screen the my calendar control */
export const CALENDAR_HOME_SCREEN = "Calendar Home Screen";

/** @description Able to edit Order Code In on Case Header in ME */
export const CAN_EDIT_ORDER_CODE_IN = "Can Edit Order Code In";

/** @description Able to edit Stack Code on Case Header in ME */
export const CAN_EDIT_STACK_CODE = "Can Edit Stack Code";

/** @description Able to edit Stamps on Survey Type Settings */
export const CAN_EDIT_STAMPS = "Can Edit Stamps";

/** @description Allow user to reject a case that is in QA */
export const CAN_REJECT_CASES = "Can Reject Cases";

/** @description Able to view Order Code In on Case Header in ME */
export const CAN_VIEW_ORDER_CODE_IN = "Can View Order Code In";

/** @description Able to view Stack Code on Case Header in ME */
export const CAN_VIEW_STACK_CODE = "Can View Stack Code";

/** @description Allows the user to edit appraisal cases in statuses normally only editable by an appraiser. */
export const CANEDITAPPRAISALSINAPPRAISERSTATUS = "CanEditAppraisalsInAppraiserStatus";

/** @description Allow the user to Edit an Inspection Appointment on a Case */
export const CASE_APPOINTMENT_DATE_EDIT = "Case Appointment Date Edit";

/** @description View appraiser availability calendar on cases */
export const CASE_APPRAISER_SCHEDULE_VIEW = "Case Appraiser Schedule View";

/** @description Allow user to Upload an attachment to a case.  These are just reference files that do not get merged */
export const CASE_ATTACHMENT_UPLOAD = "Case Attachment Upload";

/** @description Grants the right to overturn a completed audit result */
export const CASE_AUDITS_OVERTURN = "Case Audits Overturn";

/** @description Allow the user to Add a Call Log on a Case */
export const CASE_CALL_LOG_ADD = "Case Call Log Add";

/** @description Allow the user to Delete a Call Log on a Case */
export const CASE_CALL_LOG_DELETE = "Case Call Log Delete";

/** @description Allow the user to Edit an existing Call Log on a Case */
export const CASE_CALL_LOG_EDIT = "Case Call Log Edit";

/** @description Allows user to Cancel a case */
export const CASE_CANCEL = "Case Cancel";

/** @description Allows user to get credit for Scheduling or completing Phone Surveys */
export const CASE_COMPLETE_SCHEDULING_CREDIT = "Case Complete Scheduling Credit";

/** @description Allows edits to CaseConfigurations. */
export const CASE_CONFIGURATIONS_EDIT = "Case Configurations Edit";

/** @description Allow user to create a copy of a case */
export const CASE_DUPLICATE = "Case Duplicate";

/** @description Allow user to create a duplicate case with limited options for customers */
export const CASE_DUPLICATE_FOR_CUSTOMER = "Case Duplicate for Customer";

/** @description Allow user to create a copy of a case with a different account and survey type */
export const CASE_DUPLICATE_WITH_ACCOUNT_SURVEY_TYPE = "Case Duplicate With Account Survey Type";

/** @description Right to set a custom From address on a case email */
export const CASE_EMAIL_FROM_EDIT = "Case Email From Edit";

/** @description Allow user to send an email from Mueller Enterprise */
export const CASE_EMAIL_SEND = "Case Email Send";

/** @description Allow user to send a UW Permission To Close email */
export const CASE_EMAIL_SEND_UW_PERMISSION_TO_CLOSE = "Case Email Send UW Permission To Close";

/** @description Allow user to send a UW Permission To Extend email */
export const CASE_EMAIL_SEND_UW_PERMISSION_TO_EXTEND = "Case Email Send UW Permission To Extend";

/** @description Allow user to view ETA fields */
export const CASE_ETA_VIEW = "Case ETA View";

/** @description Quick List displaying Case Export Results */
export const CASE_EXPORT_QUICK_LISTS = "Case Export Quick Lists";

/** @description Allow a user to create an extension request on a case */
export const CASE_EXTENSION_REQUEST_ADD = "Case Extension Request Add";

/** @description Base quick list query for case feedback */
export const CASE_FEEDBACK_BASE_QUERY = "Case Feedback Base Query";

/** @description Allow user to delete case files */
export const CASE_FILE_DELETE = "Case File Delete";

/** @description Allow user to download case files */
export const CASE_FILE_DOWNLOAD = "Case File Download";

/** @description Allows user to regenerate Final PDF report. Example: [controlnumber]-Report.pdf */
export const CASE_FILE_REGENERATE_REPORT_PDF = "Case File Regenerate Report PDF";

/** @description Allow user to Upload a file to a case */
export const CASE_FILE_UPLOAD = "Case File Upload";

/** @description Allow user to use view case files */
export const CASE_FILE_VIEW = "Case File View";

/** @description Allows user to see Mueller generated files before case is completed. Example [controlnumber]-Report. */
export const CASE_FILE_VIEW_GENERATED_FILES_BEFORE_COMPLETED = "Case File View Generated Files Before Completed";

/** @description Allow user to add to the case form data history */
export const CASE_FORM_DATA_REVISIONS_EDIT = "Case Form Data Revisions Edit";

/** @description Allow user to see list of case form data history */
export const CASE_FORM_DATA_REVISIONS_VIEW = "Case Form Data Revisions View";

/** @description Allow user to add any case form on a case */
export const CASE_FORMS_CAN_ADD_ANY = "Case Forms Can Add Any";

/** @description Allows adding forms that arent supplements to a case */
export const CASE_FORMS_CAN_ADD_NON_SUPPLEMENTS = "Case Forms Can Add Non-Supplements";

/** @description Allow user to add and remove forms from a case */
export const CASE_FORMS_MAINTENANCE = "Case Forms Maintenance";

/** @description Allows the user to see a list of field reps that can work on a case (based on region and designation */
export const CASE_FR_SCHEDULE_VIEW = "Case FR Schedule View";

/** @description Allow user to edit the geo-coordinates for a case */
export const CASE_GEOCODE_EDIT = "Case Geocode Edit";

/** @description Allow user to view the geo-coordinates for a case */
export const CASE_GEOCODE_VIEW = "Case Geocode View";

/** @description Able to edit account number on the case header */
export const CASE_HEADER_ACCOUNT_NUMBER_EDIT = "Case Header Account Number Edit";

/** @description Able to edit agent code on the case header */
export const CASE_HEADER_AGENT_CODE_EDIT = "Case Header Agent Code Edit";

/** @description Able to edit business type on the case header */
export const CASE_HEADER_BUSINESS_TYPE_EDIT = "Case Header Business Type Edit";

/** @description Allow user to edit Coverage A Endorsed field on the Case Header */
export const CASE_HEADER_COVERAGE_A_ENDORSED_EDIT = "Case Header Coverage A Endorsed Edit";

/** @description Able to view coverage A on the case header */
export const CASE_HEADER_COVERAGE_A_ENDORSED_VIEW = "Case Header Coverage A Endorsed View";

/** @description Able to edit date received on the case header */
export const CASE_HEADER_DATE_RECEIVED_EDIT = "Case Header Date Received Edit";

/** @description Able to edit due date on the case header */
export const CASE_HEADER_DUE_DATE_EDIT = "Case Header Due Date Edit";

/** @description Able to edit case header */
export const CASE_HEADER_EDIT = "Case Header Edit";

/** @description Able to edit effective date on the case header */
export const CASE_HEADER_EFFECTIVE_DATE_EDIT = "Case Header Effective Date Edit";

/** @description Able to edit mailing address on the case header */
export const CASE_HEADER_MAILING_ADDRESS_EDIT = "Case Header Mailing Address Edit";

/** @description Able to change case ordered date */
export const CASE_HEADER_ORDERED_DATE_EDIT = "Case Header Ordered Date Edit";

/** @description Allow user to view original survey type in order info card */
export const CASE_HEADER_ORIGINAL_SURVEY_TYPE_VIEW = "Case Header Original Survey Type View";

/** @description Able to edit policy holder contact info like phone number and email address on the case header */
export const CASE_HEADER_POLICY_HOLDER_CONTACT_INFO_EDIT = "Case Header Policy Holder Contact Info Edit";

/** @description Able to view policy holder contact info like phone number and email address on the case header */
export const CASE_HEADER_POLICY_HOLDER_CONTACT_INFO_VIEW = "Case Header Policy Holder Contact Info View";

/** @description Able to edit first last name on the case header */
export const CASE_HEADER_POLICY_HOLDER_FIRST_LAST_NAME_EDIT = "Case Header Policy Holder First Last Name Edit";

/** @description Able to view policy holder first last name on the case header */
export const CASE_HEADER_POLICY_HOLDER_FIRST_LAST_NAME_VIEW = "Case Header Policy Holder First Last Name View";

/** @description Able to edit policy number on the case header */
export const CASE_HEADER_POLICY_NUMBER_EDIT = "Case Header Policy Number Edit";

/** @description Able to view private notes on the case header */
export const CASE_HEADER_PRIVATE_NOTES_VIEW = "Case Header Private Notes View";

/** @description Able to view case header that filters fields based on view/edit rights */
export const CASE_HEADER_RIGHT_FILTERED_VIEW = "Case Header Right Filtered View";

/** @description Able to edit rush box on the case header */
export const CASE_HEADER_RUSH_BOX_EDIT = "Case Header Rush Box Edit";

/** @description Able to special attention notes on the case header */
export const CASE_HEADER_SPECIAL_ATTENTION_NOTES_EDIT = "Case Header Special Attention Notes Edit";

/** @description Able to edit survey address on the case header */
export const CASE_HEADER_SURVEY_ADDRESS_EDIT = "Case Header Survey Address Edit";

/** @description Able to edit survey type on the case header */
export const CASE_HEADER_SURVEY_TYPE_EDIT = "Case Header Survey Type Edit";

/** @description Able to change case surveyed date */
export const CASE_HEADER_SURVEYED_DATE_EDIT = "Case Header Surveyed Date Edit";

/** @description Able to edit tracking number on the case header */
export const CASE_HEADER_TRACKING_NUMBER_EDIT = "Case Header Tracking Number Edit";

/** @description Able to edit underwriter code on the case header */
export const CASE_HEADER_UNDERWRITER_CODE_EDIT = "Case Header Underwriter Code Edit";

/** @description Able to edit year built on the case header */
export const CASE_HEADER_YEAR_BUILT_EDIT = "Case Header Year Built Edit";

/** @description Show appraisal events in the case history */
export const CASE_HISTORY_APPRAISAL_EVENT_VIEW = "Case History Appraisal Event View";

/** @description Show appraisal logs in the case history */
export const CASE_HISTORY_APPRAISAL_LOGS_VIEW = "Case History Appraisal Logs View";

/** @description Ability to edit Appraiser Notes on History tab of case view */
export const CASE_HISTORY_APPRAISER_NOTES_EDIT = "Case History Appraiser Notes Edit";

/** @description Ability to view Appraiser Notes on History tab of case view */
export const CASE_HISTORY_APPRAISER_NOTES_VIEW = "Case History Appraiser Notes View";

/** @description Show all call logs in the case history */
export const CASE_HISTORY_CALL_LOG_VIEW = "Case History Call Log View";

/** @description Able to view the mueller enterprise case history card */
export const CASE_HISTORY_CARD_VIEW = "Case History Card View";

/** @description Show case events in the case history */
export const CASE_HISTORY_CASE_EVENT_VIEW = "Case History Case Event View";

/** @description Show all customer service notes in the case history */
export const CASE_HISTORY_CUSTOMER_SERVICE_NOTES_VIEW = "Case History Customer Service Notes View";

/** @description Show all internal notes in the case history */
export const CASE_HISTORY_INTERNAL_NOTES_VIEW = "Case History Internal Notes View";

/** @description Show all case issues in the case history */
export const CASE_HISTORY_ISSUE_VIEW = "Case History Issue View";

/** @description Able to view the me case History List component in case profile */
export const CASE_HISTORY_LIST_VIEW = "Case History List View";

/** @description Show preferred appointment in the case history */
export const CASE_HISTORY_PREFERRED_APPOINTMENT_VIEW = "Case History Preferred Appointment View";

/** @description Show reconsiderations in the case history */
export const CASE_HISTORY_RECONSIDERATION_VIEW = "Case History Reconsideration View";

/** @description Show all system touches case events in the case history */
export const CASE_HISTORY_SYSTEM_TOUCHES_VIEW = "Case History System Touches View";

/** @description Show time logs in the case history */
export const CASE_HISTORY_TIME_LOGS_VIEW = "Case History Time Logs View";

/** @description Show all touches in the case history */
export const CASE_HISTORY_TOUCHES_VIEW = "Case History Touches View";

/** @description Allow user to put a case on hold or remove a hold */
export const CASE_HOLD_UPDATE = "Case Hold Update";

/** @description Allows a user to edit case issues associated to a case */
export const CASE_ISSUES_EDIT = "Case Issues Edit";

/** @description Allows a user to view case issues associated to a case */
export const CASE_ISSUES_VIEW = "Case Issues View";

/** @description Allow user to view, add, edit and delete a note on a case */
export const CASE_NOTE_MAINTENANCE = "Case Note Maintenance";

/** @description Allows user to view and re-send case notifications */
export const CASE_NOTIFICATIONS = "Case Notifications";

/** @description Able to view the mueller enterprise case Private Notes */
export const CASE_PRIVATE_NOTES_VIEW = "Case Private Notes View";

/** @description Able to view case profile */
export const CASE_PROFILE_VIEW = "Case Profile View";

/** @description Allows user to view Property Case History card */
export const CASE_PROPERTY_HISTORY_VIEW = "Case Property History View";

/** @description Allows user to view Property Case History card with results limited to the current case customer */
export const CASE_PROPERTY_HISTORY_VIEW_LIMITED = "Case Property History View Limited";

/** @description Allows a user to quality review a case */
export const CASE_QUALITY_REVIEW = "Case Quality Review";

/** @description Displays change case Status card in Maintenance and gives ability to change the status of the case i */
export const CASE_STATUS_CHANGE = "Case Status Change";

/** @description Enables the case status tracker for the current user */
export const CASE_STATUS_TRACKER_VIEW = "Case Status Tracker View";

/** @description Allows the user to view all time logs for all users */
export const CASE_TIMELOGS_VIEW_ALL = "Case TimeLogs View All";

/** @description Allow user to add a case travel log  */
export const CASE_TRAVEL_LOGS_ADD = "Case Travel Logs Add";

/** @description Allow user to remove a case travel log */
export const CASE_TRAVEL_LOGS_DELETE = "Case Travel Logs Delete";

/** @description Allow user to update a case travel log  */
export const CASE_TRAVEL_LOGS_UPDATE = "Case Travel Logs Update";

/** @description Allow user view case logs */
export const CASE_TRAVEL_LOGS_VIEW = "Case Travel Logs View";

/** @description Allow user to view validation status of a case */
export const CASE_VALIDATION_VIEW = "Case Validation View";

/** @description Allow a user to perform valuation review on a case */
export const CASE_VALUATION_REVIEW = "Case Valuation Review";

/** @description Allow user to edit Client ETA field */
export const CLIENT_ETA_EDIT = "Client ETA Edit";

/** @description Able to clock in or out */
export const CLOCK_IN_OR_OUT_FUNCTION = "Clock In Or Out Function";

/** @description User is allowed to use the Collateral Analytics Risk Profiler */
export const COLLATERAL_ANALYTICS_RISK_PROFILER = "Collateral Analytics - Risk Profiler";

/** @description Limit viewing of cases to the Company this person is associated with. */
export const COMPANYFILTER = "COMPANYFILTER";

/** @description Be able to view the comparable grid on the case */
export const COMPARABLE_GRID_VIEW = "Comparable Grid View";

/** @description Allow to import comparables from an uploaded MISMO file */
export const COMPARABLE_IMPORT_FROM_MISMO_FILE = "Comparable Import from MISMO File";

/** @description Shows the "Contact Us" Sidebar Link on ME */
export const CONTACT_US_SIDEBAR_LINK_ME = "Contact Us Sidebar Link ME";

/** @description Allow the user to edit content library projects, topics, and resources */
export const CONTENT_LIBRARY_EDIT = "Content Library Edit";

/** @description Allow the user to view content library projects, topics, and resources */
export const CONTENT_LIBRARY_VIEW = "Content Library View";

/** @description Allow user to convert a case to a different survey type. */
export const CONVERT_CASE = "Convert Case";

/** @description Able to add courses */
export const COURSE_ADD = "Course Add";

/** @description Able to edit courses */
export const COURSE_EDIT = "Course Edit";

/** @description Can add HR courses */
export const COURSE_HR_ADD = "Course HR Add";

/** @description Can edit HR courses in courses list */
export const COURSE_HR_EDIT = "Course HR Edit";

/** @description Can view HR courses in courses list */
export const COURSE_HR_VIEW = "Course HR View";

/** @description Able to view courses */
export const COURSE_VIEW = "Course View";

/** @description Allow user to view the QA Coverage card */
export const COVERAGE_CARD_VIEW = "Coverage Card View";

/** @description Allows the user to order Data Mining reports on Coverage Keeper */
export const COVKEEPER_DATAMINING = "COVKEEPER_DATAMINING";

/** @description Allow access to CubiCasa AdvancedEdit */
export const CUBICASA_ADVANCEDEDIT = "CubiCasa AdvancedEdit";

/** @description Allow to submit a CubiCasa Fix Request */
export const CUBICASA_FIX_REQUEST = "CubiCasa Fix Request";

/** @description Allow access to CubiCasa QuickEdit */
export const CUBICASA_QUICKEDIT = "CubiCasa QuickEdit";

/** @description Allow user to create new customer accounts */
export const CUSTOMER_ACCOUNT_CREATE = "Customer Account Create";

/** @description Able to edit account details on customer settings */
export const CUSTOMER_ACCOUNT_EDIT = "Customer Account Edit";

/** @description Allows a create to view Customer Agents */
export const CUSTOMER_AGENT_CREATE = "Customer Agent Create";

/** @description Allows a user to edit Customer Agents */
export const CUSTOMER_AGENT_EDIT = "Customer Agent Edit";

/** @description Allows a user to view Customer Agents */
export const CUSTOMER_AGENT_VIEW = "Customer Agent View";

/** @description Base quick list query for appraisal customers */
export const CUSTOMER_APPRAISAL_BASE_QUERY = "Customer Appraisal Base Query";

/** @description Allow User to view, add, or delete any customer appraiser exclusion associations */
export const CUSTOMER_APPRAISER_EXCLUSION_MAINTENANCE = "Customer Appraiser Exclusion Maintenance";

/** @description Allows user to add, edit, or delete customer calc settings */
export const CUSTOMER_CALC_SETTINGS_EDIT = "Customer Calc Settings Edit";

/** @description Customer Details Edit */
export const CUSTOMER_DETAILS_EDIT = "Customer Details Edit";

/** @description Customer Details View */
export const CUSTOMER_DETAILS_VIEW = "Customer Details View";

/** @description Allow manager to log coaching call for a Customer Experience employee */
export const CUSTOMER_EXPERIENCE_COACHING_CALL = "Customer Experience Coaching Call";

/** @description Flags user as part of the Customer Experience group. Currently handles forms to display and/or valid */
export const CUSTOMER_EXPERIENCE_USER = "Customer Experience User";

/** @description Allow user to Add/Update/Delete Customer Insight Notification Setups */
export const CUSTOMER_INSIGHT_NOTIFICATION_EDIT = "Customer Insight Notification Edit";

/** @description Allow user to see Customer Insight Notification Setups */
export const CUSTOMER_INSIGHT_NOTIFICATION_VIEW = "Customer Insight Notification View";

/** @description Allow User to view, add, or delete any customer inspector exclusion associations */
export const CUSTOMER_INSPECTOR_EXCLUSION_MAINTENANCE = "Customer Inspector Exclusion Maintenance";

/** @description Base quick list query for insurance customers */
export const CUSTOMER_INSURANCE_BASE_QUERY = "Customer Insurance Base Query";

/** @description Allow use to go to the run customer invoicing processes */
export const CUSTOMER_INVOICING_MAINTENANCE = "Customer Invoicing Maintenance";

/** @description Customer List/Search View */
export const CUSTOMER_LIST_VIEW = "Customer List View";

/** @description Allow user to edit customer notification settings */
export const CUSTOMER_NOTIFICATIONS_EDIT = "Customer Notifications Edit";

/** @description Right to edit the PDF Settings for a customer */
export const CUSTOMER_PDF_SETTINGS_EDIT = "Customer PDF Settings Edit";

/** @description Allow user to edit customer sales settings */
export const CUSTOMER_SALES_DETAILS_EDIT = "Customer Sales Details Edit";

/** @description Base quicklist query for customer satisfaction surveys */
export const CUSTOMER_SATISFACTION_SURVEY_BASE_QUERY = "Customer Satisfaction Survey Base Query";

/** @description Allow access to a customer scorecard view */
export const CUSTOMER_SCORECARD_VIEW = "Customer Scorecard View";

/** @description Allow user to send an email to customer service from Mueller Enterprise */
export const CUSTOMER_SERVICE_EMAIL_SEND = "Customer Service Email Send";

/** @description Allow user to Add a Customer Service Incident / Inquiry */
export const CUSTOMER_SERVICE_INCIDENT_ADD = "Customer Service Incident Add";

/** @description Allow user to close a Customer Service Incident / Inquiry */
export const CUSTOMER_SERVICE_INCIDENT_CLOSE = "Customer Service Incident Close";

/** @description Allow user to Delete a Customer Service Incident / Inquiry */
export const CUSTOMER_SERVICE_INCIDENT_DELETE = "Customer Service Incident Delete";

/** @description Allow user to view all details of a CS Incident */
export const CUSTOMER_SERVICE_INCIDENT_DETAILS_VIEW = "Customer Service Incident Details View";

/** @description Allow user to Update a Customer Service Incident / Inquiry */
export const CUSTOMER_SERVICE_INCIDENT_UPDATE = "Customer Service Incident Update";

/** @description Allow user to edit customer survey type setup */
export const CUSTOMER_SURVEY_TYPE_EDIT = "Customer Survey Type Edit";

/** @description Allow user to view customer survey type setup */
export const CUSTOMER_SURVEY_TYPE_VIEW = "Customer Survey Type View";

/** @description Allows user to view there customer files in the marketing directory (MarketingAttachments) */
export const CUSTOMERFOLDERS = "CUSTOMERFOLDERS";

/** @description Allowed to distribute costs to data vendor operations */
export const DATA_VENDOR_COST_ALLOCATION_EDIT = "Data Vendor Cost Allocation Edit";

/** @description Allows the user to delete a Paid Stamp on a case */
export const DELETEPAIDSTAMP = "DELETEPAIDSTAMP";

/** @description Makes ME not route to the legacy portal if the requested redirect has no parameters. */
export const DIRECT_LEGACY_PORTAL_ACCESS_DISABLED = "Direct Legacy Portal Access Disabled";

/** @description Allow user to add a message to a Dwelling Blocks integrated Case */
export const DWELLING_BLOCKS_MESSAGE_ADD = "Dwelling Blocks Message Add";

/** @description Allow user to edit cases. */
export const EDIT = "EDIT";

/** @description Allows user to edit review comments */
export const EDITREVIEWCOMMENTS = "EDITREVIEWCOMMENTS";

/** @description Allow employees to edit their own calendar */
export const EMPLOYEE_CALENDAR_EDIT = "Employee Calendar Edit";

/** @description Allow user to edit employee complaints */
export const EMPLOYEE_COMPLAINT_EDIT = "Employee Complaint Edit";

/** @description Allow user to view employee complaints */
export const EMPLOYEE_COMPLAINT_VIEW = "Employee Complaint View";

/** @description Allows user to view all office employee information */
export const EMPLOYEE_CONTACT_FULL_VIEW = "Employee Contact Full View";

/** @description Allows User to view office employee information */
export const EMPLOYEE_CONTACT_VIEW = "Employee Contact View";

/** @description Able to add courses to an employee */
export const EMPLOYEE_COURSE_ADD = "Employee Course Add";

/** @description Able to delete a course assigned to an employee */
export const EMPLOYEE_COURSE_DELETE = "Employee Course Delete";

/** @description Able to Edit a course assigned to an employee.  Mostly used to add score and completion */
export const EMPLOYEE_COURSE_EDIT = "Employee Course Edit";

/** @description Can add HR courses in employee list of courses */
export const EMPLOYEE_COURSE_HR_ADD = "Employee Course HR Add";

/** @description Can edit HR courses in employee list of courses */
export const EMPLOYEE_COURSE_HR_EDIT = "Employee Course HR Edit";

/** @description Can view HR courses in employee list of courses */
export const EMPLOYEE_COURSE_HR_VIEW = "Employee Course HR View";

/** @description Able to view courses assigned to the employee */
export const EMPLOYEE_COURSE_VIEW = "Employee Course View";

/** @description Allows user to edit any employee MAC adjustments */
export const EMPLOYEE_MAC_ADJUSTMENT_EDIT = "Employee MAC Adjustment Edit";

/** @description Allows user to view any employee MAC adjustments */
export const EMPLOYEE_MAC_ADJUSTMENT_VIEW = "Employee MAC Adjustment View";

/** @description Allow user to Edit an Employee Pay Rate */
export const EMPLOYEE_PAY_RATE_EDIT = "Employee Pay Rate Edit";

/** @description Allow user to View an Employee Pay Rate */
export const EMPLOYEE_PAY_RATE_VIEW = "Employee Pay Rate View";

/** @description Able to add courses to an employee role */
export const EMPLOYEE_ROLE_COURSE_ADD = "Employee Role Course Add";

/** @description Able to delete a course from an employee role */
export const EMPLOYEE_ROLE_COURSE_DELETE = "Employee Role Course Delete";

/** @description Able to view employee roles assigned to courses */
export const EMPLOYEE_ROLE_COURSE_VIEW = "Employee Role Course View";

/** @description Edit employee start date */
export const EMPLOYEE_START_DATE_EDIT = "Employee Start Date Edit";

/** @description Allow user to edit employee training completed date */
export const EMPLOYEE_TRAINING_EDIT = "Employee Training Edit";

/** @description Employee Notes Add */
export const EMPLOYEENOTES_ADD = "EmployeeNotes_Add";

/** @description Employee Notes View */
export const EMPLOYEENOTES_VIEW = "EmployeeNotes_View";

/** @description Can initiate an export retry */
export const EXPORT_RETRY = "Export Retry";

/** @description Can initiate an export on a case */
export const EXPORT_START = "Export Start";

/** @description Can view exports available to run */
export const EXPORTS_AVAILABLE_VIEW = "Exports Available View";

/** @description Can view export results on cases */
export const EXPORTS_RESULTS_VIEW = "Exports Results View";

/** @description Allow user to view Field Appointment Mappings */
export const FIELD_APPOINTMENT_QUEUE_MAPPING_VIEW = "Field Appointment Queue Mapping View";

/** @description Allow user to edit Field Inspection ETA field */
export const FIELD_INSPECTION_ETA_EDIT = "Field Inspection ETA Edit";

/** @description Can assign any case to a FR regardless of designations */
export const FIELD_REP_ASSIGNMENT_OVERRIDE = "Field Rep Assignment Override";

/** @description Base query for field rep quick list */
export const FIELD_REP_BASE_QUERY = "Field Rep Base Query";

/** @description If set to true, allows the user to update "Can be assigned cases" attribute on a Field Rep Detail */
export const FIELD_REP_CAN_BE_ASSIGNED_CASES_EDIT = "Field Rep Can Be Assigned Cases Edit";

/** @description Allows user to view inspector case log on a case */
export const FIELD_REP_CASE_LOG_EDIT = "Field Rep Case Log Edit";

/** @description Allows user to view inspector case log on a case */
export const FIELD_REP_CASE_LOG_VIEW = "Field Rep Case Log View";

/** @description Allows user to create new Field Reps */
export const FIELD_REP_CREATE = "Field Rep Create";

/** @description Allows editing the Field Rep automatic assignment switch */
export const FIELD_REP_DISABLE_AUTO_ASSIGN_EDIT = "Field Rep Disable Auto Assign Edit";

/** @description Allows a user to edit the Elite High Value field rep designation */
export const FIELD_REP_ELITE_DESIGNATION_EDIT = "Field Rep Elite Designation Edit";

/** @description Able to view Field Rep Login Link */
export const FIELD_REP_LOGIN_VIEW = "Field Rep Login View";

/** @description Able to add or remove field rep designations */
export const FIELD_REP_PROFILE_DESIGNATIONS_EDIT = "Field Rep Profile Designations Edit";

/** @description Able to view field rep designations */
export const FIELD_REP_PROFILE_DESIGNATIONS_VIEW = "Field Rep Profile Designations View";

/** @description Allows user to edit an Inspector Service Region */
export const FIELD_REP_SERVICE_REGION_EDIT = "Field Rep Service Region Edit";

/** @description Allows user to view an Inspector Service Region */
export const FIELD_REP_SERVICE_REGION_VIEW = "Field Rep Service Region View";

/** @description Allow user to view and approve Field Rep Timelogs for a pay period */
export const FIELD_REP_TIMELOGS_APPROVE_VIEW = "Field Rep Timelogs Approve View";

/** @description Allow user to edit field rep travel logs */
export const FIELD_REP_TRAVEL_LOG_EDIT = "Field Rep Travel Log Edit";

/** @description Allow user to view field rep travel logs */
export const FIELD_REP_TRAVEL_LOG_VIEW = "Field Rep Travel Log View";

/** @description Right to Assign a case for Field Services Scheduling to another user */
export const FIELD_SCHEDULING_ASSIGN = "Field Scheduling Assign";

/** @description Right to view the scheduling assistant quick list */
export const FIELD_SCHEDULING_BASE_QUERY = "Field Scheduling Base Query";

/** @description Right to perform Team Lead functionality on a case for Field Services Scheduling */
export const FIELD_SCHEDULING_MANAGE = "Field Scheduling Manage";

/** @description Add or remove survey type mappings for field scheduling employees */
export const FIELD_SCHEDULING_MAPPING_EDIT = "Field Scheduling Mapping Edit";

/** @description Right to Review a case for Field Services Scheduling */
export const FIELD_SCHEDULING_REVIEW = "Field Scheduling Review";

/** @description Right to Review a searched case for Field Services Scheduling */
export const FIELD_SCHEDULING_SEARCH_VIEW = "Field Scheduling Search View";

/** @description Allows adding cases to Field Service auto QA queue */
export const FIELD_SERVICE_AUTO_QA_BATCH_ADD = "Field Service Auto QA Batch Add";

/** @description Allow user to access Field Rep training */
export const FIELD_TRAINING_VIEW = "Field Training View";

/** @description Able to view Field Rep Tooltips in ME */
export const FIELDREP_TOOLTIPS_ME = "FieldRep Tooltips ME";

/** @description View field rep List */
export const FIELDREPLIST_VIEW = "FieldRepList View";

/** @description Allows users to edit FR profiles */
export const FIELDREPPROFILE_EDIT = "FieldRepProfile Edit";

/** @description Able to view Field Rep Profiles */
export const FIELDREPPROFILE_VIEW = "FieldRepProfile View";

/** @description Allow to View List of Field Level Coordinators */
export const FLC_LIST_VIEW = "FLC List View";

/** @description User is able to modify what regions are assigned to a Field Level Coordinator */
export const FLC_REGION_MAINTENANCE = "FLC Region Maintenance";

/** @description Force the search header to show.... Don't ask... It's for Role #8 "Allstate Guy" - Mark B. */
export const FORCESEARCHHEADER = "FORCESEARCHHEADER";

/** @description Grants access to edit a phoenix form in the designer */
export const FORM_DESIGN_EDIT = "Form Design Edit";

/** @description Grants access to view a phoenix form in the designer */
export const FORM_DESIGN_VIEW = "Form Design View";

/** @description Allows the generation of form error reports */
export const FORM_ERROR_REPORT_CREATE = "Form Error Report Create";

/** @description Allows editing of form details */
export const FORM_MAINTENANCE_EDIT = "Form Maintenance Edit";

/** @description Grants access to forms list and form detail view */
export const FORM_MAINTENANCE_VIEW = "Form Maintenance View";

/** @description Automatically displays photo viewer on the right side of the forms. */
export const FORM_PHOTO_VIEWER_SPLIT_VIEW = "Form Photo Viewer Split View";

/** @description Allows editing of form rules */
export const FORM_RULES_MAINTENANCE_EDIT = "Form Rules Maintenance Edit";

/** @description Grants access to forms rules list and form rules view */
export const FORM_RULES_MAINTENANCE_VIEW = "Form Rules Maintenance View";

/** @description Allow to View List of Field Service Directors */
export const FSD_LIST_VIEW = "FSD List View";

/** @description User can have an underwriter record associated with their account */
export const HAS_UNDERWRITER = "Has Underwriter";

/** @description Allow user to view Homeowners QA Mappings */
export const HOMEOWNERS_QA_QUEUE_MAPPING_VIEW = "Homeowners QA Queue Mapping View";

/** @description Allow user to edit HR info */
export const HR_INFO_EDIT = "HR Info Edit";

/** @description Allow user to add/remove watches for inspection events */
export const INSPECTION_EVENT_WATCH = "Inspection Event Watch";

/** @description Allows user to move a case to the top of the Queue */
export const INSPECTION_QUEUE_CASE_MOVE_TO_TOP = "Inspection Queue Case Move To Top";

/** @description Assign Inspection Service Region to Counties */
export const INSPECTION_SERVICE_ASSIGN_REGION = "Inspection Service Assign Region";

/** @description Allow user to login to the inspector application */
export const INSPECTORAPP = "INSPECTORAPP";

/** @description Allows impersonating another user on certain pages on the Classic site */
export const INSPECTORAPP_MASQUERADE = "InspectorApp Masquerade";

/** @description Allow users to see internal photos.  Example: FR Selfie Photo */
export const INTERNAL_PHOTOS_VIEW = "Internal Photos View";

/** @description Is an inspector */
export const ISINSPECTOR = "ISINSPECTOR";

/** @description Can Edit Telephone Agent Cases */
export const ISTELEPHONEAGENT = "ISTELEPHONEAGENT";

/** @description Able to view Legacy Dashboard in ME */
export const LEGACY_DASHBOARD = "Legacy Dashboard";

/** @description Allow to view legacy data entry page */
export const LEGACY_DATA_ENTRY_PAGE = "Legacy Data Entry Page";

/** @description Allow editing of any employee calendar */
export const MANAGEMENT_CALENDAR_EDIT = "Management Calendar Edit";

/** @description Allow management to view employees calendars */
export const MANAGEMENT_CALENDAR_VIEW = "Management Calendar View";

/** @description Allows user to view there marketing files in the marketing directory (MarketingAttachments) */
export const MARKETINGFOLDERS = "MARKETINGFOLDERS";

/** @description Allow user to view management reports */
export const MREPORTS = "MREPORTS";

/** @description Access to field rep reporting site columns */
export const MREPORTS_FIELD = "MREPORTS_FIELD";

/** @description Full access to internal Mueller reporting site columns */
export const MREPORTS_INTERNAL = "MREPORTS_INTERNAL";

/** @description Able to view own time logs */
export const MY_TIMELOGS_VIEW = "My TimeLogs View";

/** @description Displays the new 1004p form view instead of the phoenix form */
export const NEW_1004P_FORM_VIEW = "New 1004p Form View";

/** @description Displays the new comp grid and hides the old comp gird */
export const NEW_COMP_GRID = "New Comp Grid";

/** @description When this right is enabled, the user should be able to edit pnx form data in ME, as well as see the  */
export const OPEN_CASES_EDIT = "Open Cases Edit";

/** @description Allows user to edit Operations Director profiles */
export const OPERATIONS_DIRECTOR_PROFILE_EDIT = "Operations Director Profile Edit";

/** @description Allows user to view Operations Director profiles */
export const OPERATIONS_DIRECTOR_PROFILE_VIEW = "Operations Director Profile View";

/** @description Allows user to edit OM profiles */
export const OPERATIONS_MANAGER_PROFILE_EDIT = "Operations Manager Profile Edit";

/** @description Allows user to view OM profiles */
export const OPERATIONS_MANAGER_PROFILE_VIEW = "Operations Manager Profile View";

/** @description Allow user to access standard and batch order page */
export const ORDER = "ORDER";

/** @description Allows user to run a payroll */
export const PAYROLL_RUN = "Payroll Run";

/** @description Allows user to view the summary on employee payroll */
export const PAYROLL_VIEW = "Payroll View";

/** @description Allows the user the edit the PDF class */
export const PDF_CLASS_EDIT = "PDF Class Edit";

/** @description Allows the user the view the PDF class */
export const PDF_CLASS_VIEW = "PDF Class View";

/** @description Allow user to create a new phone support call */
export const PHONE_SUPPORT_CALL_CREATE = "Phone Support Call Create";

/** @description Allow user to view phone support calls on cases or employees */
export const PHONE_SUPPORT_CALL_VIEW = "Phone Support Call View";

/** @description Used to grant employee roles read-only access to photos on cases. */
export const PHOTO_READ_UNRESTRICTED = "Photo Read Unrestricted";

/** @description Used to grant employee roles unrestricted access to photos on cases. */
export const PHOTO_WRITE_UNRESTRICTED = "Photo Write Unrestricted";

/** @description Allow user to access v2 ordering page */
export const PLACE_ORDER_VIEW = "Place Order View";

/** @description Allow the user to View Pre-Noticiation Instruction with Call Script on a Case */
export const PRE_NOTIFICATION_INSTRUCTION_VIEW = "Pre-Notification Instruction View";

/** @description Allow user to view Preferred Appointment Mappings */
export const PREFERRED_APPOINTMENT_QUEUE_MAPPING_VIEW = "Preferred Appointment Queue Mapping View";

/** @description Able to edit the private notes field. */
export const PRIVATE_NOTES_EDIT = "Private Notes Edit";

/** @description Edit PTO for ODs */
export const PTO_OPERATIONS_DIRECTOR_ADD = "Pto Operations Director Add";

/** @description View PTO for ODs */
export const PTO_OPERATIONS_DIRECTOR_VIEW = "Pto Operations Director View";

/** @description Edit PTO for LMs and LLMs */
export const PTO_OPERATIONS_MANAGER_ADD = "Pto Operations Manager Add";

/** @description View PTO for OMs and LLMs */
export const PTO_OPERATIONS_MANAGER_VIEW = "Pto Operations Manager View";

/** @description Allow user to edit form data on cases */
export const QA = "QA";

/** @description Base query for QA agent quick list */
export const QA_AGENT_BASE_QUERY = "QA Agent Base Query";

/** @description Base query for QA Audit compliance quick list */
export const QA_AUDIT_COMPLIANCE_BASE_QUERY = "QA Audit Compliance Base Query";

/** @description Base quicklist query for QA audit review cases */
export const QA_AUDIT_REVIEW_BASE_QUERY = "QA Audit Review Base Query";

/** @description Allow user to edit and save audits on the Case Audit tab. */
export const QA_CASE_AUDIT_EDIT = "QA Case Audit Edit";

/** @description Allow user to edit and save audit feedbacks on the Case Audit tab. */
export const QA_CASE_AUDIT_FEEDBACK_EDIT = "QA Case Audit Feedback Edit";

/** @description Allow user to view the Case Audit tab on completed cases. */
export const QA_CASE_AUDIT_VIEW = "QA Case Audit View";

/** @description Can view case info for QA cases */
export const QA_CASE_INFO_VIEW = "QA Case Info View";

/** @description Able to view QA Cases Link */
export const QA_CASES_VIEW = "QA Cases View";

/** @description Allow user to view QA dashboard */
export const QA_DASHBOARD_VIEW = "QA Dashboard View";

/** @description Able to view QA Profile */
export const QA_DETAIL_VIEW = "QA Detail View";

/** @description Right for QA to edit the data on a completed case */
export const QA_EDIT_COMPLETED_CASES = "QA Edit Completed Cases";

/** @description Base quicklist query for QA insurance cases */
export const QA_INSURANCE_BASE_QUERY = "QA Insurance Base Query";

/** @description Able to view QA List */
export const QA_LIST_VIEW = "QA List View";

/** @description Allows user to see QA Director drop down on Payroll Page */
export const QA_PAYROLL_PAGE_DIRECTOR_DROPDOWN_VIEW = "QA Payroll Page Director Dropdown View";

/** @description Allow manager to log coaching call for a QA employee */
export const QA_PHONE_SUPPORT_COACHING_CALL = "QA Phone Support Coaching Call";

/** @description QA Queue cases assigned to user will not time out */
export const QA_QUEUE_UNLIMITED_TIMEOUT = "QA Queue Unlimited Timeout";

/** @description Allows user to view QA rejection card issues */
export const QA_REJECTION_CARD_VIEW = "QA Rejection Card View";

/** @description Allow user to Edit QA Team Customer association */
export const QA_TEAM_CUSTOMER_EDIT = "QA Team Customer Edit";

/** @description Allow user to view QA Team Customer association */
export const QA_TEAM_CUSTOMER_VIEW = "QA Team Customer View";

/** @description Allows the user to change the team someone is on and manage teams */
export const QA_TEAM_MAINTENANCE = "QA Team Maintenance";

/** @description Allow QA user to view their own time log summary */
export const QA_TIME_LOG_SUMMARY_VIEW = "QA Time Log Summary View";

/** @description Indicates time spent on a case should be logged */
export const QA_TIMER_TIMELOGS_ADD = "QA Timer Timelogs Add";

/** @description Able to view QAM List in Maintenance */
export const QAM_LIST_VIEW = "QAM List View";

/** @description Allow user to assign cases in the QA queue */
export const QUALITY_REVIEW_ASSIGN = "Quality Review Assign";

/** @description Allow user to view any QADs queue mappings */
export const QUEUE_MAPPINGS_ALL_VIEW = "Queue Mappings All View";

/** @description Allow users to view and use Quick Filters */
export const QUICK_FILTERS_USE = "Quick Filters Use";

/** @description Able to create or edit a quick list */
export const QUICKLIST_EDIT = "QuickList Edit";

/** @description Able to generate a quicklist group share link */
export const QUICKLIST_GROUP_SHARE = "QuickList Group Share";

/** @description Allows a user to work with the Customer Service Incident Quick List */
export const QUICKLIST_INCIDENT_TEMPLATE_VIEW = "QuickList Incident Template View";

/** @description QuickList to show the Inspector Hiring Need Forecast Template */
export const QUICKLIST_INSPECTOR_HIRING_FORECAST_TEMPLATE_VIEW = "QuickList Inspector Hiring Forecast Template View";

/** @description Able to generate a quick list share link */
export const QUICKLIST_SHARE = "QuickList Share";

/** @description Able to view a quick list */
export const QUICKLIST_VIEW = "QuickList View";

/** @description Allows multiple commits if the customer account has "RCT FIT Single Commit Restriction" enabled */
export const RCT_FIT_COMMIT_UNLIMITED = "RCT FIT Commit Unlimited";

/** @description Grants the user the right to perform team lead review of a QA case */
export const RECEIVE_QA_CASES_FOR_REVIEW = "Receive QA Cases For Review";

/** @description Used to redirect the user to the Mueller Enterprise platform */
export const REDIRECT_TO_MUELLER_ENTERPRISE = "Redirect to Mueller Enterprise";

/** @description Route user to the legacy website after login */
export const REDIRECT_TO_MUELLER_LEGACY_PORTAL = "Redirect To Mueller Legacy Portal";

/** @description Shows the related cases card on the case view */
export const RELATED_CASES_VIEW = "Related Cases View";

/** @description Allow user to see "Review Cases" Link */
export const REVIEW = "REVIEW";

/** @description Adds quicklist to dashboard for all users requiring visibility over their follow-ups */
export const REVIEW_FOLLOW_UPS = "Review Follow Ups";

/** @description User is able to view the risk profiler results & PDF */
export const RISK_PROFILER_VIEW = "Risk Profiler View";

/** @description Able to edit Roles Rights */
export const ROLE_RIGHTS_EDIT = "Role Rights Edit";

/** @description Able to view Roles Rights */
export const ROLE_RIGHTS_VIEW = "Role Rights View";

/** @description Assigned to a Scheduling user to see the My Time Logs page */
export const SCHEDULING_ASSISTANT_VIEW_MY_TIME_LOGS = "Scheduling Assistant View My Time Logs";

/** @description Able to approve Scheduling TimeLogs */
export const SCHEDULING_ASSISTANTS_TIMELOGS_APPROVE = "Scheduling Assistants TimeLogs Approve";

/** @description Able to view Scheduling TimeLogs */
export const SCHEDULING_ASSISTANTS_TIMELOGS_VIEW = "Scheduling Assistants TimeLogs View";

/** @description Allow user to Add, Update, Delete Field Scheduling Time Logs */
export const SCHEDULING_CASE_TIME_LOG_MAINTENANCE = "Scheduling Case Time Log Maintenance";

/** @description Allows user to move a case to the top of the Queue */
export const SCHEDULING_QUEUE_CASE_MOVE_TO_TOP = "Scheduling Queue Case Move To Top";

/** @description Allows users to initiate Mueller@Home inspections on the website */
export const SEND_MUELLER_HOME_LINK = "Send Mueller@Home Link";

/** @description Allow Service Region Delete */
export const SERVICE_REGION_DELETE = "Service Region Delete";

/** @description Allow Service Region Edit */
export const SERVICE_REGION_EDIT = "Service Region Edit";

/** @description Allow Service Region View */
export const SERVICE_REGION_VIEW = "Service Region View";

/** @description Defaults the quick list editor to be simple mode */
export const SIMPLE_QUICK_LIST_EDIT = "Simple Quick List Edit";

/** @description Makes Sketch editable when the Service Type of Appraisal is checked and Field Service is not checked */
export const SKETCH_DESKTOP_APPRAISAL_WRITE = "Sketch Desktop Appraisal Write";

/** @description Shows the Sketch Discrapancy info within the Property Tax Record card on ME */
export const SKETCH_DISCREPANCY_VIEW = "Sketch Discrepancy View";

/** @description View any sketch */
export const SKETCH_READ_UNRESTRICTED = "Sketch Read Unrestricted";

/** @description Save any sketch */
export const SKETCH_WRITE_UNRESTRICTED = "Sketch Write Unrestricted";

/** @description Able to view stamp and photo requirements link in case info */
export const STAMP_PHOTO_REQUIREMENTS_LINK_VIEW = "Stamp and Photo Requirements Link View";

/** @description Adds quicklist to dashboard for all broker orders */
export const STATIC_QL_ALL_BROKER_ORDERS = "Static QL - All Broker Orders";

/** @description Adds quicklist to dashboard for appraisal cases in Available To Appraiser status */
export const STATIC_QL_AVAILABLE_TO_APPRAISER = "Static QL - Available to Appraiser";

/** @description Adds quicklist to dashboard for appraisal cases in Completed status */
export const STATIC_QL_COMPLETED_APPRAISAL = "Static QL - Completed Appraisal";

/** @description Adds quicklist to dashboard for completed broker orders */
export const STATIC_QL_COMPLETED_BROKER_ORDERS = "Static QL - Completed Broker Orders";

/** @description Adds quicklist to the dashboard for cases that need underwriter review and are not assigned to under */
export const STATIC_QL_CUSTOMER_REVIEW_OPEN_UNASSIGNED = "Static QL - Customer Review Open and Unassigned";

/** @description Adds quicklist to dashboard for cases past due for underwriter review */
export const STATIC_QL_CUSTOMER_REVIEW_PAST_DUE = "Static QL - Customer Review Past Due";

/** @description Adds quicklist to dashboard for customer service incidents assigned to current user */
export const STATIC_QL_CUSTOMER_SERVICE_INCIDENTS = "Static QL - Customer Service Incidents";

/** @description Adds quicklist to the dashboard for field reps where field manager is current user */
export const STATIC_QL_FM_ACTIVE_FIELD_REPS = "Static QL - FM Active Field Reps";

/** @description Adds quicklist to the dashboard for cases on new accounts where field manager is current user */
export const STATIC_QL_FM_NEW_CUSTOMER = "Static QL - FM New Customer";

/** @description Adds quicklist to the dashboard for unassigned closeout cases where field manager is current user */
export const STATIC_QL_FM_UNASSIGNED_CLOSEOUTS = "Static QL - FM Unassigned Closeouts";

/** @description Adds quicklist to the dashboard for unassigned preferred appointment cases where field manager is cu */
export const STATIC_QL_FM_UNASSIGNED_PREFERRED_APPT = "Static QL - FM Unassigned Preferred Appt";

/** @description Adds quicklist to the dashboard for unassigned specialty cases greater than 10 days old where field  */
export const STATIC_QL_FM_UNASSIGNED_SPECIALTY_10_DAYS = "Static QL - FM Unassigned Specialty 10 Days";

/** @description Adds quicklist to the dashboard for unassigned cases with an appointment where field manager is curr */
export const STATIC_QL_FM_UNASSIGNED_WITH_APPOINTMENT = "Static QL - FM Unassigned With Appointment";

/** @description Adds quicklist to dashboard for all open appraisal cases */
export const STATIC_QL_OPEN_APPRAISALS = "Static QL - Open Appraisals";

/** @description Adds quicklist to dashboard for open broker orders */
export const STATIC_QL_OPEN_BROKER_ORDERS = "Static QL - Open Broker Orders";

/** @description Adds quicklist to dashboard for QA cases assigned to current user */
export const STATIC_QL_QA_ASSIGNED_CASES = "Static QL - QA Assigned Cases";

/** @description Adds quicklist to dashboard for QA audits needing review by current user */
export const STATIC_QL_QA_AUDIT_REVIEW = "Static QL - QA Audit Review";

/** @description Adds quicklist to dashboard for cases requiring audit filtered by logged in QA Director */
export const STATIC_QL_QA_DIRECTOR_AUDIT_REQUIRED = "Static QL - QA Director Audit Required";

/** @description Adds quicklist to dashboard for cases requiring audit filtered by logged in QA Manager */
export const STATIC_QL_QA_MANAGER_AUDIT_REQUIRED = "Static QL - QA Manager Audit Required";

/** @description Adds quicklist to dashboard for cases ready for underwriter review by current user */
export const STATIC_QL_READY_FOR_CUSTOMER_REVIEW = "Static QL - Ready For Customer Review";

/** @description Adds quicklist to dashboard for appraisal cases that have been returned to the appraiser */
export const STATIC_QL_RETURNED_APPRAISAL = "Static QL - Returned Appraisal";

/** @description Adds quicklist to dashboard for case exports where valuation coordinator is current user */
export const STATIC_QL_VALUATION_COORDINATOR_CASE_EXPORTS = "Static QL - Valuation Coordinator Case Exports";

/** @description Adds quicklist to dashboard for declined approval cases where valuation coordinator is current user */
export const STATIC_QL_VALUATION_COORDINATOR_DECLINED_CASES = "Static QL - Valuation Coordinator Declined Cases";

/** @description Adds quicklist to dashboard for pending approval cases where valuation coordinator is current user */
export const STATIC_QL_VALUATION_COORDINATOR_PENDING_CASES = "Static QL - Valuation Coordinator Pending Cases";

/** @description Adds quicklist to dashboard for case exports where valuation director is current user */
export const STATIC_QL_VALUATION_DIRECTOR_CASE_EXPORTS = "Static QL - Valuation Director Case Exports";

/** @description Adds quicklist to dashboard for declined cases where valuation director is current user */
export const STATIC_QL_VALUATION_DIRECTOR_DECLINED_CASES = "Static QL - Valuation Director Declined Cases";

/** @description Adds quicklist to dashboard for pending approval cases where valuation director is current user */
export const STATIC_QL_VALUATION_DIRECTOR_PENDING_APPROVAL = "Static QL - Valuation Director Pending Approval";

/** @description Adds quicklist to dashboard so Agency users can see their cases */
export const STATICQL_AGENCY_CASE_LIST = "StaticQL-Agency Case List";

/** @description Adds quicklist to dashboard for all users showing their assigned queue */
export const STATICQL_CER_ASSIGNED_QUEUE = "StaticQL-CER Assigned Queue";

/** @description Adds quicklist to dashboard for all users requiring visibility over their follow-ups */
export const STATICQL_CER_FOLLOW_UP = "StaticQL-CER Follow-Up";

/** @description Allow user to submit a case to QA from the field. */
export const SUBMIT_CASE_QA = "Submit Case QA";

/** @description Displays the new History tab */
export const TABBED_HISTORY_VIEW = "Tabbed History View";

/** @description Is a team leader */
export const TEAMLEADER = "TEAMLEADER";

/** @description Allow user to Add a Clock in and out for another user */
export const TIME_CLOCK_ADD = "Time Clock Add";

/** @description Allow user to Delete a Clock in and out for another user */
export const TIME_CLOCK_DELETE = "Time Clock Delete";

/** @description Allow user to Update a Clock in and out for another user */
export const TIME_CLOCK_UPDATE = "Time Clock Update";

/** @description Allows downloading from the Time Review pages */
export const TIME_REVIEW_DOWNLOAD = "Time Review Download";

/** @description Allows assigning cases to underwriters */
export const UNDERWRITER_ASSIGN = "Underwriter Assign";

/** @description Allows a user to edit an Underwriter record */
export const UNDERWRITER_EDIT = "Underwriter Edit";

/** @description Allows user to view underwriter details */
export const UNDERWRITER_VIEW_TOOLTIP = "Underwriter View Tooltip";

/** @description Makes the Underwriting Action Taken field required */
export const UNDERWRITINGACTIONTAKENREQD = "UNDERWRITINGACTIONTAKENREQD";

/** @description Do not allow email to be used as MFA verification method */
export const USER_MULTI_FACTOR_METHOD_EMAIL_DENY = "User Multi-Factor Method Email Deny";

/** @description Do not allow text message to be used as MFA verification method */
export const USER_MULTI_FACTOR_METHOD_TEXT_DENY = "User Multi-Factor Method Text Deny";

/** @description Do not allow MFA device tokens */
export const USER_MULTI_FACTOR_REMEMBER_ME_DENY = "User Multi-Factor Remember Me Deny";

/** @description Expire MFA tokens after 12 hours */
export const USER_MULTI_FACTOR_REMEMBER_ME_EXPIRATION_12_HOUR = "User Multi-Factor Remember Me Expiration 12 Hour";

/** @description MFA tokens do not expire */
export const USER_MULTI_FACTOR_REMEMBER_ME_EXPIRATION_DISABLED = "User Multi-Factor Remember Me Expiration Disabled";

/** @description Multi-Factor setup required */
export const USER_MULTI_FACTOR_REQUIRED = "User Multi-Factor Required";

/** @description Can edit the multi-factor settings of any user */
export const USER_MULTI_FACTOR_SETTINGS_EDIT = "User Multi-Factor Settings Edit";

/** @description Limit viewing of cases to cases this Person has personally worked on. */
export const USERFILTER = "USERFILTER";

/** @description Can view an applicants details */
export const VIEWAPPLICANT = "VIEWAPPLICANT";

/** @description Include website error details in the website response */
export const WEBSITE_ERROR_DETAILS_VIEW = "Website Error Details View";